export default "__VITE_ASSET__B8j0v2jg__"